<div class="cg-dialog">
  <h2
    data-test="leave-page-dialog-header"
    class="cg-dialog__header cg-dialog__header--modal"
  >
    {{ data.heading }}
    <button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      data-test="close-btn"
      (click)="leavePageDialogRef.close(false)"
    >
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <div class="cg-margin-bottom-xl" data-test="leave-page-content">
      <p [innerHTML]="data.content"></p>
    </div>

    <div class="cg-button-group cg-margin-bottom-sm cg-flex-center">
      <button
        cignaButton="primary"
        type="submit"
        data-test="stay-on-page-btn"
        (click)="leavePageDialogRef.close(false)"
      >
        Stay on page
      </button>
      <button
        class="cg-margin-left-xl"
        cignaButton="link no-underline inline"
        type="button"
        data-test="leave-btn"
        (click)="leavePageDialogRef.close(true)"
      >
        Leave
      </button>
    </div>
  </mat-dialog-content>
</div>
